import ReviewStars from "../../shared/review-stars";

export default function EmptyReviewsPreview() {
  return (
    <div className="empty-reviews-preview" data-test-id="empty-reviews-preview">
      <div className="inline-block review-stars">
        <ReviewStars imageName="BlackStars0" />
        <p className="body-3-size">0 Reviews</p>
      </div>
      <p className="body-1-size">No Reviews Yet</p>
      <p className="body-3-size">Be the first to leave a review!</p>
    </div>
  );
}
